import { EventBus } from '@marketplace/plugins/event-bus.js'

let cookieMessagePageCounter = 0

/**
 * Hide the cookie message after changing the route.
 */
export default function () {
    if (cookieMessagePageCounter === 0) {
        EventBus.$emit('destroyCookieMessage')
        cookieMessagePageCounter += 1
    }
}
